import script from "./YTableDeleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./YTableDeleteButton.vue?vue&type=script&setup=true&lang=js"

import "./YTableDeleteButton.vue?vue&type=style&index=0&id=40485965&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40485965"]])

export default __exports__